import { observer } from 'mobx-react-lite';

import { Badge } from '@/components/ui/Badge';
import { chatEngineStore } from '@/features/chat/chat-engine.store';

type ChatEngineBadgeProps = {
  /** The chat's thread ID, or the composer draft ID before New Chat's first send */
  chatKey: string;
};

export const ChatEngineBadge = observer(function ChatEngineBadge({
  chatKey,
}: ChatEngineBadgeProps) {
  if (chatEngineStore.engineByChat[chatKey] !== 'v5') return null;

  return (
    <Badge variant="secondary" title="This chat runs on the chat_v5 API">
      v5
    </Badge>
  );
});
